import React, { useContext } from 'react';
import { Typography, useToast } from '@pw-tech/omni-ui';
import { RegistrationContext } from '@/modules/RegisterLayout/contexts/RegistrationContextProvider';
import FooterPortal from '@/modules/common/Portals/FooterPortal/FooterPortal';
import { InfoIcon, Monitor } from 'lucide-react';
const ExamInProgress = () => {
  const {
    registrationDetails
  } = useContext(RegistrationContext);
  const {
    toast: showToaster
  } = useToast();
  const handleMettlRedirect = (link: string) => {
    if (!link) {
      showToaster({
        message: 'Link not available',
        variant: 'error',
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'center'
        }
      });
      return;
    }
    window.open(link, '_blank');
  };
  return <article data-sentry-component="ExamInProgress" data-sentry-source-file="ExamInProgress.tsx">
      <Typography variant="heading3" weight="semi-bold" className="mb-4" data-sentry-element="Typography" data-sentry-source-file="ExamInProgress.tsx">
        Fast Track Process Video Interview
      </Typography>
      <div className="bg-[#EFF6FF] border border-[#93C5FD] rounded-lg p-4">
        <div className="flex flex-col items-center gap-4">
          <div className="flex items-center justify-center w-12 h-12 rounded-full bg-[#DBEAFE]">
            <Monitor size={24} color="#2563EB" data-sentry-element="Monitor" data-sentry-source-file="ExamInProgress.tsx" />
          </div>
          <div className="mx-auto text-center">
            <Typography component="div" variant="heading4" weight="semi-bold" data-sentry-element="Typography" data-sentry-source-file="ExamInProgress.tsx">
              Your Video Interview is In Progress
            </Typography>
            <Typography component="div" variant="regular" className="!text-sm !text-[#3D3D3D] mt-2 max-w-[400px]" data-sentry-element="Typography" data-sentry-source-file="ExamInProgress.tsx">
              It looks like you've already started the Video Interview. Click below to continue
              where you left off.
            </Typography>
          </div>
        </div>
      </div>
      <div className="flex items-center gap-2 mt-4">
        <div className="flex items-center justify-center flex-shrink-0">
          <InfoIcon size={20} data-sentry-element="InfoIcon" data-sentry-source-file="ExamInProgress.tsx" />
        </div>
        <Typography variant="regular" className="!text-sm !text-[#757575]" data-sentry-element="Typography" data-sentry-source-file="ExamInProgress.tsx">
          Make sure you have a stable internet connection before resuming the Video Interview.
        </Typography>
      </div>
      <div className="h-8" />
      <div className="py-2">
        <FooterPortal label="Resume Video Interview" type="button" btnWrapperClass="relative sm:left-[31%]" onClick={() => handleMettlRedirect(registrationDetails?.testUrl ?? '')} data-sentry-element="FooterPortal" data-sentry-source-file="ExamInProgress.tsx" />
      </div>
    </article>;
};
export default ExamInProgress;